module.exports={render:function (){
var _obj, _obj$1, _obj$2;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('gs-header', {
    attrs: {
      "title": "Chi tiết đối soát",
      "breadcrumbs": [{
        title: 'Phiên đối soát',
        route: {
          name: 'compare'
        }
      }]
    }
  }, [_c('el-popover', {
    ref: "applyPopup",
    attrs: {
      "placement": "top",
      "width": "200"
    },
    model: {
      value: (_vm.applyPopup),
      callback: function($$v) {
        _vm.applyPopup = $$v
      },
      expression: "applyPopup"
    }
  }, [_c('p', [_vm._v("Bạn xác nhận đối soát này?")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin": "0"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.applyPopup = false
      }
    }
  }, [_vm._v("Không")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary",
      "disabled": _vm.applyCompareSubmitting,
      "loading": _vm.applyCompareSubmitting
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.applyCompare.apply(null, arguments)
      }
    }
  }, [_vm._v("Xác\n          nhận")])], 1)]), _vm._v(" "), _c('el-popover', {
    ref: "removePopup",
    attrs: {
      "placement": "top",
      "width": "200"
    },
    model: {
      value: (_vm.removePopup),
      callback: function($$v) {
        _vm.removePopup = $$v
      },
      expression: "removePopup"
    }
  }, [_c('p', [_vm._v("Bạn xác nhận hủy đối soát này?")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin": "0"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.removePopup = false
      }
    }
  }, [_vm._v("Không")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.removeCompare.apply(null, arguments)
      }
    }
  }, [_vm._v("Xác nhận")])], 1)]), _vm._v(" "), (_vm.canEdit) ? _c('el-button', {
    directives: [{
      name: "popover",
      rawName: "v-popover:applyPopup",
      arg: "applyPopup"
    }],
    attrs: {
      "size": "small",
      "type": "success",
      "icon": "el-icon-finished"
    },
    on: {
      "click": function($event) {
        _vm.applyPopup = !_vm.applyPopup
      }
    }
  }, [_vm._v("Xác nhận\n      đối\n      soát")]) : _vm._e(), _vm._v(" "), (_vm.canEdit) ? _c('el-button', {
    attrs: {
      "size": "small",
      "type": "warning",
      "icon": "el-icon-check"
    },
    on: {
      "click": _vm.verifyCrossCheck
    }
  }, [_vm._v("Duyệt đối\n      soát")]) : _vm._e(), _vm._v(" "), (_vm.canEdit) ? _c('el-button', {
    directives: [{
      name: "popover",
      rawName: "v-popover:removePopup",
      arg: "removePopup"
    }],
    attrs: {
      "size": "small",
      "type": "danger",
      "icon": "el-icon-remove"
    },
    on: {
      "click": function($event) {
        _vm.removePopup = !_vm.removePopup
      }
    }
  }, [_vm._v("Hủy đối\n      soát")]) : _vm._e(), _vm._v(" "), (_vm.canEdit) ? _c('el-button', {
    attrs: {
      "size": "small",
      "icon": "el-icon-plus"
    },
    on: {
      "click": function($event) {
        _vm.addShipmentModal = !_vm.addShipmentModal
      }
    }
  }, [_vm._v("Thêm vận\n      đơn")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "text",
      "icon": "el-icon-download"
    },
    on: {
      "click": _vm.exportExcel
    }
  }, [_vm._v("Xuất\n      excel")])], 1), _vm._v(" "), _c('div', {
    staticClass: "padding-sm-all"
  }, [_c('el-row', {
    staticClass: "padding-all",
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-descriptions', {
    staticClass: "margin-top",
    attrs: {
      "title": "Tổng quan",
      "column": 2,
      "border": ""
    }
  }, [_c('el-descriptions-item', [_c('template', {
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-collection-tag"
  }), _vm._v("\n              Đơn thành công\n            ")]), _vm._v("\n            " + _vm._s(_vm._f("number")(_vm.crossChecks.num_compare_success)) + "\n          ")], 2), _vm._v(" "), _c('el-descriptions-item', [_c('template', {
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-warning-outline"
  }), _vm._v("\n              Đơn lỗi\n            ")]), _vm._v(" "), _c('span', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm._f("number")(_vm.crossChecks.num_compare_error)))])], 2), _vm._v(" "), (_vm.getCrossCheckKind(_vm.CROSS_CHECK_TYPE.COD)) ? _c('el-descriptions-item', [_c('template', {
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-money"
  }), _vm._v("\n              COD hãng thu\n            ")]), _vm._v("\n            " + _vm._s(_vm._f("vnd")(_vm.crossChecks.cod_carrier)) + "\n          ")], 2) : _vm._e(), _vm._v(" "), (_vm.getCrossCheckKind(_vm.CROSS_CHECK_TYPE.COD)) ? _c('el-descriptions-item', [_c('template', {
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-coin"
  }), _vm._v("\n              COD hãng trả\n            ")]), _vm._v("\n            " + _vm._s(_vm._f("vnd")(_vm.crossChecks.cod_goship)) + "\n          ")], 2) : _vm._e(), _vm._v(" "), _c('el-descriptions-item', [_c('template', {
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-money"
  }), _vm._v("\n              " + _vm._s(_vm.getCrossCheckKind(_vm.CROSS_CHECK_TYPE.COD) ? 'Tổng phí thu' : 'Tổng phí đối soát lần 1') + "\n            ")]), _vm._v("\n            " + _vm._s(_vm._f("vnd")(_vm.crossChecks.fee_goship)) + "\n          ")], 2), _vm._v(" "), _c('el-descriptions-item', [_c('template', {
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-coin"
  }), _vm._v("\n              " + _vm._s(_vm.getCrossCheckKind(_vm.CROSS_CHECK_TYPE.COD) ? 'Tổng phí trả' : 'Tổng phí đối soát') + "\n            ")]), _vm._v("\n            " + _vm._s(_vm._f("vnd")(_vm.crossChecks.fee_carrier)) + "\n          ")], 2)], 1)], 1), _vm._v(" "), (_vm.getCrossCheckKind(_vm.CROSS_CHECK_TYPE.COD)) ? _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('h3', {
    staticStyle: {
      "margin": "15px 0"
    }
  }, [_vm._v("COD trả shop")]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "data": _vm.financeReport,
      "border": "",
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Hãng vận chuyển",
      "prop": "carrier"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Tổng COD",
      "prop": "cod"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Tiền phí",
      "prop": "fee"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Tiền phải trả",
      "prop": "total_pay"
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.typeofCompare) ? [_c('gs-table', {
    ref: _vm.listtingCompareTable,
    attrs: {
      "cache-data": false,
      "table-name": _vm.listtingCompareTable,
      "data-source": _vm.typeofCompare + this.$route.params.id,
      "data-params": _vm.filters,
      "data-sorted": _vm.sorted,
      "data-sorts": _vm.sorts
    },
    on: {
      "remove-filter": _vm.removeFilter
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(datas) {
        return [(_vm.getCrossCheckKind(_vm.CROSS_CHECK_TYPE.COD)) ? _c('el-table', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "data": datas.data,
            "border": ""
          }
        }, [_c('el-table-column', {
          attrs: {
            "label": "#",
            "width": "50",
            "align": "center"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(_vm.dataPaginations[_vm.listtingCompareTable]) ? _c('small', [_vm._v(_vm._s((scope.$index + 1) +
                ((_vm.dataPaginations[_vm.listtingCompareTable].current_page - 1) *
                  _vm.dataPaginations[_vm.listtingCompareTable].per_page)))]) : _vm._e()]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Đối Soát",
            "width": "200"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.shipment) ? _c('p', {
                class: _vm.shipmentStatuses[scope.row.shipment.data.status]
              }, [_c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Trạng thái vận đơn"
                }
              }, [_c('span', [_c('i', {
                staticClass: "fa fa-file-text-o",
                attrs: {
                  "aria-hidden": "true"
                }
              }), _vm._v(" " + _vm._s(scope.row.shipment.data.status_txt) + "\n                      "), (scope.row.shipment.data.is_return) ? _c('small', [_vm._v("(Chuyển hoàn)")]) : _vm._e(), (scope.row.shipment.data.is_part_delivery) ? _c('small', [_vm._v("(Giao một phần)")]) : _vm._e(), (scope.row.shipment.data.is_lost) ? _c('small', [_vm._v("(Thất lạc)")]) : _vm._e()])])], 1) : _vm._e(), _vm._v(" "), _c('p', {
                class: _vm.listtingComparesStatus[scope.row.status]
              }, [_c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Trạng thái"
                }
              }, [_c('span', [_c('i', {
                staticClass: "fa fa-info-circle",
                attrs: {
                  "aria-hidden": "true"
                }
              }), _vm._v(" " + _vm._s(scope.row.status_txt))])])], 1), _vm._v(" "), _c('p', {
                staticClass: "text-red"
              }, [_c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Trạng thái lỗi"
                }
              }, [_c('span', [_c('i', {
                staticClass: "fa fa-exclamation-circle",
                attrs: {
                  "aria-hidden": "true"
                }
              }), _vm._v(" " + _vm._s(scope.row.error_txt))])])], 1), _vm._v(" "), _c('p', [_c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Ngày tạo"
                }
              }, [_c('span', [_c('i', {
                staticClass: "fa fa-clock-o",
                attrs: {
                  "aria-hidden": "true"
                }
              }), _vm._v(" " + _vm._s(scope.row.created_at))])])], 1)]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.shipment) ? _c('p', [_c('span', [_vm._v("Mã vận đơn: ")]), (scope.row.shipment) ? _c('span', {
                staticClass: "shipment-code-display click-copy"
              }, [_vm._v(_vm._s(scope.row.shipment.data.id))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (scope.row.shipment) ? _c('p', [_c('span', [_vm._v("Mã đơn HVC: ")]), _vm._v(" "), _c('span', {
                staticClass: "shipment-code-display click-copy"
              }, [_vm._v(_vm._s(scope.row.code))])]) : _vm._e(), _vm._v(" "), (scope.row.shipment && scope.row.shipment.data.invoice) ? _c('p', [_c('span', [_vm._v("Mã phiếu chi: ")]), _vm._v(" "), _c('span', {
                staticClass: "shipment-code-display click-copy"
              }, [_vm._v(_vm._s(scope.row.shipment.data.invoice.data.id))])]) : _vm._e()]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Thông Tin Khách Hàng"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.shipment && scope.row.client) ? _c('p', [_c('i', {
                staticClass: "fa fa-user"
              }), _vm._v(" " + _vm._s(scope.row.client.data.name))]) : _vm._e(), _vm._v(" "), (scope.row.shipment && scope.row.client) ? _c('p', [_c('i', {
                staticClass: "fa fa-mobile"
              }), _vm._v(" "), _c('span', {
                staticClass: "click-copy"
              }, [_vm._v(_vm._s(scope.row.client.data.phone))])]) : _vm._e(), _vm._v(" "), (scope.row.shipment && scope.row.client) ? _c('p', [_c('i', {
                staticClass: "fa fa-envelope-o",
                attrs: {
                  "aria-hidden": "true"
                }
              }), _vm._v(" "), _c('span', {
                staticClass: "click-copy"
              }, [_vm._v(_vm._s(scope.row.client.data.email))])]) : _vm._e()]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('p', [_vm._v("Tiền thu hộ (COD)")]), _vm._v(" "), _c('p', [_vm._v("Tổng phí")]), _vm._v(" "), _c('p', [_vm._v("Đã thu")]), _vm._v(" "), _c('p', [_vm._v("Cần thu")]), _vm._v(" "), _c('p', [_vm._v("Cân nặng")])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Thông Tin Đối Soát"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('div', [_c('p', {
                staticClass: "text-right click-copy text-red"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.cod_amount)))]), _vm._v(" "), _c('p', {
                staticClass: "text-right click-copy text-red"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.total_fee + scope.row.last_total_fee)))]), _vm._v(" "), _c('p', {
                staticClass: "text-right click-copy text-red"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.last_total_fee)))]), _vm._v(" "), _c('p', {
                staticClass: "text-right click-copy text-red"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.total_fee)))]), _vm._v(" "), _c('p', {
                staticClass: "text-right click-copy text-red"
              }, [_vm._v(_vm._s(_vm._f("gam")(scope.row.weight)))])])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Thông Tin Vận Đơn"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('div', [(scope.row.shipment) ? _c('p', {
                staticClass: "click-copy text-red"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.shipment.data.amount_for_cross)))]) : _vm._e(), _vm._v(" "), (scope.row.shipment) ? _c('p', {
                staticClass: "click-copy text-red"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.shipment.data.total_fee)))]) : _vm._e(), _vm._v(" "), (scope.row.shipment) ? _c('p', {
                staticClass: "click-copy text-red"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.last_payed_fee)))]) : _vm._e(), _vm._v(" "), (scope.row.shipment) ? _c('p', {
                staticClass: "click-copy text-red"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.shipment.data.total_fee - scope.row.last_payed_fee)))]) : _vm._e()]), _vm._v(" "), (scope.row.parcel) ? _c('p', {
                staticClass: "click-copy text-red"
              }, [_vm._v(_vm._s(_vm._f("gam")(_vm.isOverweight(scope))))]) : _vm._e()]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Thông tin tài chính"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('div', [(scope.row.shipment) ? _c('p', [_vm._v("Doanh thu: "), _c('span', {
                staticClass: "pull-right click-copy text-red"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.shipment.data.total_fee)))])]) : _vm._e(), _vm._v(" "), (scope.row.shipment) ? _c('p', [_vm._v("Chi phí: "), _c('span', {
                staticClass: "pull-right click-copy text-red"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.total_fee + scope.row.last_total_fee)))])]) : _vm._e(), _vm._v(" "), (scope.row.shipment) ? _c('p', [_vm._v("Lợi nhuận: "), _c('span', {
                staticClass: "pull-right click-copy text-red"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.shipment.data.total_fee - scope.row.total_fee - scope.row.last_total_fee)))])]) : _vm._e()])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "width": "50"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('section', {
                staticClass: "padding-sm-top padding-sm-bottom"
              }, [_c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Sửa"
                }
              }, [_c('a', {
                staticClass: "text-orange padding-all display-inline-block cursor-pointer",
                on: {
                  "click": function($event) {
                    return _vm.editListtingCompare(scope.row)
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-pencil-square-o"
              })])]), _vm._v(" "), (scope.row.shipment && scope.row.shipment.data.can_hard_update && _vm.isCheckUpgrade) ? _c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Cập nhập thông tin"
                }
              }, [_c('a', {
                staticClass: "text-brown padding-all display-inline-block cursor-pointer",
                on: {
                  "click": function($event) {
                    return _vm.showEditShipment(scope.row.shipment)
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-pencil"
              })])]) : _vm._e(), _vm._v(" "), (scope.row.error) ? _c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Xóa"
                }
              }, [_c('a', {
                staticClass: "text-red padding-all display-inline-block cursor-pointer",
                on: {
                  "click": function($event) {
                    return _vm.deleteListtingCompare(scope.row)
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-trash"
              })])]) : _vm._e()], 1)]
            }
          }], null, true)
        })], 1) : _vm._e(), _vm._v(" "), (_vm.getCrossCheckKind(_vm.CROSS_CHECK_TYPE.FEE)) ? _c('el-table', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "data": datas.data,
            "border": ""
          }
        }, [_c('el-table-column', {
          attrs: {
            "label": "#",
            "width": "50",
            "align": "center"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(_vm.dataPaginations[_vm.listtingCompareTable]) ? _c('small', [_vm._v(_vm._s((scope.$index + 1) +
                ((_vm.dataPaginations[_vm.listtingCompareTable].current_page - 1) *
                  _vm.dataPaginations[_vm.listtingCompareTable].per_page)))]) : _vm._e()]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Đối Soát",
            "width": "200"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.shipment) ? _c('p', {
                class: _vm.shipmentStatuses[scope.row.shipment.data.status]
              }, [_c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Trạng thái vận đơn"
                }
              }, [_c('span', [_c('i', {
                staticClass: "fa fa-file-text-o",
                attrs: {
                  "aria-hidden": "true"
                }
              }), _vm._v(" " + _vm._s(scope.row.shipment.data.status_txt) + "\n                    "), (scope.row.shipment.data.is_return) ? _c('small', [_vm._v("(Chuyển hoàn)")]) : _vm._e(), (scope.row.shipment.data.is_part_delivery) ? _c('small', [_vm._v("(Giao một phần)")]) : _vm._e(), (scope.row.shipment.data.is_lost) ? _c('small', [_vm._v("(Thất lạc)")]) : _vm._e()])])], 1) : _vm._e(), _vm._v(" "), _c('p', {
                class: _vm.listtingComparesStatus[scope.row.status]
              }, [_c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Trạng thái"
                }
              }, [_c('span', [_c('i', {
                staticClass: "fa fa-info-circle",
                attrs: {
                  "aria-hidden": "true"
                }
              }), _vm._v(" " + _vm._s(scope.row.status_txt))])])], 1), _vm._v(" "), _c('p', {
                staticClass: "text-red"
              }, [_c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Trạng thái lỗi"
                }
              }, [_c('span', [_c('i', {
                staticClass: "fa fa-exclamation-circle",
                attrs: {
                  "aria-hidden": "true"
                }
              }), _vm._v(" " + _vm._s(scope.row.error_txt))])])], 1), _vm._v(" "), _c('p', [_c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Ngày tạo"
                }
              }, [_c('span', [_c('i', {
                staticClass: "fa fa-clock-o",
                attrs: {
                  "aria-hidden": "true"
                }
              }), _vm._v(" " + _vm._s(scope.row.created_at))])])], 1)]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.shipment) ? _c('p', [_c('span', [_vm._v("Mã vận đơn: ")]), (scope.row.shipment) ? _c('span', {
                staticClass: "shipment-code-display click-copy"
              }, [_vm._v(_vm._s(scope.row.shipment.data.id))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (scope.row.shipment) ? _c('p', [_c('span', [_vm._v("Mã đơn HVC: ")]), _vm._v(" "), _c('span', {
                staticClass: "shipment-code-display click-copy"
              }, [_vm._v(_vm._s(scope.row.code))])]) : _vm._e(), _vm._v(" "), (scope.row.shipment && scope.row.shipment.data.invoice_fee) ? _c('p', [_c('span', [_vm._v("Mã phiếu chi: ")]), _vm._v(" "), _c('span', {
                staticClass: "shipment-code-display click-copy"
              }, [_vm._v(_vm._s(scope.row.shipment.data.invoice_fee.data.id))])]) : _vm._e()]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Thông Tin Khách Hàng"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.shipment && scope.row.client) ? _c('p', [_c('i', {
                staticClass: "fa fa-user"
              }), _vm._v(" " + _vm._s(scope.row.client.data.name))]) : _vm._e(), _vm._v(" "), (scope.row.shipment && scope.row.client) ? _c('p', [_c('i', {
                staticClass: "fa fa-mobile"
              }), _vm._v(" "), _c('span', {
                staticClass: "click-copy"
              }, [_vm._v(_vm._s(scope.row.client.data.phone))])]) : _vm._e(), _vm._v(" "), (scope.row.shipment && scope.row.client) ? _c('p', [_c('i', {
                staticClass: "fa fa-envelope-o",
                attrs: {
                  "aria-hidden": "true"
                }
              }), _vm._v(" "), _c('span', {
                staticClass: "click-copy"
              }, [_vm._v(_vm._s(scope.row.client.data.email))])]) : _vm._e()]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('p', [_vm._v("Tổng phí")])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Thông Tin Đối Soát Lần 1"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('div', [_c('p', {
                staticClass: "text-right click-copy text-red"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.last_total_fee)))])])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Thông Tin Đối Soát"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('div', [_c('p', {
                staticClass: "text-right click-copy text-red"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.total_fee)))])])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Chênh lệch"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('p', [_c('span', {
                staticClass: "text-red"
              }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.differenceFee(scope.row.last_total_fee, scope.row.total_fee))))])])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Thông Tin Vận Đơn"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.shipment) ? _c('p', {
                staticClass: "click-copy text-red"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.shipment.data.total_fee)))]) : _vm._e()]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "width": "50"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('section', {
                staticClass: "padding-sm-top padding-sm-bottom"
              }, [_c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Sửa"
                }
              }, [_c('a', {
                staticClass: "text-orange padding-all display-inline-block cursor-pointer",
                on: {
                  "click": function($event) {
                    return _vm.editListtingCompare(scope.row)
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-pencil-square-o"
              })])]), _vm._v(" "), (scope.row.shipment && scope.row.shipment.data.can_hard_update && _vm.isCheckUpgrade) ? _c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Cập nhập thông tin"
                }
              }, [_c('a', {
                staticClass: "text-brown padding-all display-inline-block cursor-pointer",
                on: {
                  "click": function($event) {
                    return _vm.showEditShipment(scope.row.shipment)
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-pencil"
              })])]) : _vm._e(), _vm._v(" "), (scope.row.error) ? _c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Xóa"
                }
              }, [_c('a', {
                staticClass: "text-red padding-all display-inline-block cursor-pointer",
                on: {
                  "click": function($event) {
                    return _vm.deleteListtingCompare(scope.row)
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-trash"
              })])]) : _vm._e()], 1)]
            }
          }], null, true)
        })], 1) : _vm._e(), _vm._v(" "), (_vm.getCrossCheckKind(_vm.CROSS_CHECK_TYPE.FEE1)) ? _c('el-table', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "data": datas.data,
            "border": ""
          }
        }, [_c('el-table-column', {
          attrs: {
            "label": "#",
            "width": "50",
            "align": "center"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(_vm.dataPaginations[_vm.listtingCompareTable]) ? _c('small', [_vm._v(_vm._s((scope.$index + 1) +
                ((_vm.dataPaginations[_vm.listtingCompareTable].current_page - 1) *
                  _vm.dataPaginations[_vm.listtingCompareTable].per_page)))]) : _vm._e()]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Đối Soát",
            "width": "200"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.shipment) ? _c('p', {
                class: _vm.shipmentStatuses[scope.row.shipment.data.status]
              }, [_c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Trạng thái vận đơn"
                }
              }, [_c('span', [_c('i', {
                staticClass: "fa fa-file-text-o",
                attrs: {
                  "aria-hidden": "true"
                }
              }), _vm._v(" " + _vm._s(scope.row.shipment.data.status_txt) + "\n                    "), (scope.row.shipment.data.is_return) ? _c('small', [_vm._v("(Chuyển hoàn)")]) : _vm._e(), (scope.row.shipment.data.is_part_delivery) ? _c('small', [_vm._v("(Giao một phần)")]) : _vm._e(), (scope.row.shipment.data.is_lost) ? _c('small', [_vm._v("(Thất lạc)")]) : _vm._e()])])], 1) : _vm._e(), _vm._v(" "), _c('p', {
                class: _vm.listtingComparesStatus[scope.row.status]
              }, [_c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Trạng thái"
                }
              }, [_c('span', [_c('i', {
                staticClass: "fa fa-info-circle",
                attrs: {
                  "aria-hidden": "true"
                }
              }), _vm._v(" " + _vm._s(scope.row.status_txt))])])], 1), _vm._v(" "), _c('p', {
                staticClass: "text-red"
              }, [_c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Trạng thái lỗi"
                }
              }, [_c('span', [_c('i', {
                staticClass: "fa fa-exclamation-circle",
                attrs: {
                  "aria-hidden": "true"
                }
              }), _vm._v(" " + _vm._s(scope.row.error_txt))])])], 1), _vm._v(" "), _c('p', [_c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Ngày tạo"
                }
              }, [_c('span', [_c('i', {
                staticClass: "fa fa-clock-o",
                attrs: {
                  "aria-hidden": "true"
                }
              }), _vm._v(" " + _vm._s(scope.row.created_at))])])], 1)]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.shipment) ? _c('p', [_c('span', [_vm._v("Mã vận đơn: ")]), (scope.row.shipment) ? _c('span', {
                staticClass: "shipment-code-display click-copy"
              }, [_vm._v(_vm._s(scope.row.shipment.data.id))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (scope.row.shipment) ? _c('p', [_c('span', [_vm._v("Mã đơn HVC: ")]), _vm._v(" "), _c('span', {
                staticClass: "shipment-code-display click-copy"
              }, [_vm._v(_vm._s(scope.row.code))])]) : _vm._e(), _vm._v(" "), (scope.row.shipment && scope.row.shipment.data.invoice) ? _c('p', [_c('span', [_vm._v("Mã phiếu chi: ")]), _vm._v(" "), _c('span', {
                staticClass: "shipment-code-display click-copy"
              }, [_vm._v(_vm._s(scope.row.shipment.data.invoice.data.id))])]) : _vm._e()]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Thông Tin Khách Hàng"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.shipment && scope.row.client) ? _c('p', [_c('i', {
                staticClass: "fa fa-user"
              }), _vm._v(" " + _vm._s(scope.row.client.data.name))]) : _vm._e(), _vm._v(" "), (scope.row.shipment && scope.row.client) ? _c('p', [_c('i', {
                staticClass: "fa fa-mobile"
              }), _vm._v(" "), _c('span', {
                staticClass: "click-copy"
              }, [_vm._v(_vm._s(scope.row.client.data.phone))])]) : _vm._e(), _vm._v(" "), (scope.row.shipment && scope.row.client) ? _c('p', [_c('i', {
                staticClass: "fa fa-envelope-o",
                attrs: {
                  "aria-hidden": "true"
                }
              }), _vm._v(" "), _c('span', {
                staticClass: "click-copy"
              }, [_vm._v(_vm._s(scope.row.client.data.email))])]) : _vm._e()]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('p', [_vm._v("Tổng phí")]), _vm._v(" "), _c('p', [_vm._v("Đã thu")]), _vm._v(" "), _c('p', [_vm._v("Cần thu")])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Thông Tin Đối Soát"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('div', [_c('p', {
                staticClass: "text-right click-copy text-red"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.total_fee + scope.row.last_total_fee)))]), _vm._v(" "), _c('p', {
                staticClass: "text-right click-copy text-red"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.last_total_fee)))]), _vm._v(" "), _c('p', {
                staticClass: "text-right click-copy text-red"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.total_fee)))])])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Thông Tin Vận Đơn"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('div', [(scope.row.shipment) ? _c('p', {
                staticClass: "click-copy text-red"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.shipment.data.total_fee)))]) : _vm._e(), _vm._v(" "), (scope.row.shipment) ? _c('p', {
                staticClass: "click-copy text-red"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.last_payed_fee)))]) : _vm._e(), _vm._v(" "), (scope.row.shipment) ? _c('p', {
                staticClass: "click-copy text-red"
              }, [_vm._v(_vm._s(_vm._f("vnd")(scope.row.shipment.data.total_fee - scope.row.last_payed_fee)))]) : _vm._e()])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "width": "50"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('section', {
                staticClass: "padding-sm-top padding-sm-bottom"
              }, [_c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Sửa"
                }
              }, [_c('a', {
                staticClass: "text-orange padding-all display-inline-block cursor-pointer",
                on: {
                  "click": function($event) {
                    return _vm.editListtingCompare(scope.row)
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-pencil-square-o"
              })])]), _vm._v(" "), (scope.row.shipment && scope.row.shipment.data.can_hard_update && _vm.isCheckUpgrade) ? _c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Cập nhập thông tin"
                }
              }, [_c('a', {
                staticClass: "text-brown padding-all display-inline-block cursor-pointer",
                on: {
                  "click": function($event) {
                    return _vm.showEditShipment(scope.row.shipment)
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-pencil"
              })])]) : _vm._e(), _vm._v(" "), (scope.row.error) ? _c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Xóa"
                }
              }, [_c('a', {
                staticClass: "text-red padding-all display-inline-block cursor-pointer",
                on: {
                  "click": function($event) {
                    return _vm.deleteListtingCompare(scope.row)
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-trash"
              })])]) : _vm._e()], 1)]
            }
          }], null, true)
        })], 1) : _vm._e()]
      }
    }], null, false, 1564173452)
  }, [_c('section', {
    staticStyle: {
      "margin-bottom": "24px"
    },
    attrs: {
      "slot": "filters"
    },
    slot: "filters"
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [(_vm.compareHelpers.errors && _vm.getCrossCheckKind(_vm.CROSS_CHECK_TYPE.COD)) ? _c('el-radio-group', {
    staticClass: "status-listting",
    attrs: {
      "fill": _vm.listtingComparesErrorBg[_vm.filters.error_id]
    },
    on: {
      "change": _vm.filter
    },
    model: {
      value: (_vm.filters.error_id),
      callback: function($$v) {
        _vm.$set(_vm.filters, "error_id", $$v)
      },
      expression: "filters.error_id"
    }
  }, [_vm._l((_vm.compareHelpers.errors), function(error, index) {
    var _obj;

    return _c('el-radio-button', {
      key: index,
      attrs: {
        "label": index
      }
    }, [_vm._v("\n                • " + _vm._s(error) + " "), _c('span', {
      class: ( _obj = {}, _obj[_vm.listtingComparesError[index]] = _vm.filters.error_id !== index, _obj )
    }, [_vm._v("(" + _vm._s(_vm.countErrorCompare(index)) + ")")])])
  }), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": -1
    }
  }, [_vm._v("\n                • "), _c('span', {
    class: ( _obj = {}, _obj[_vm.listtingComparesError[-1]] = _vm.filters.error_id !== -1, _obj )
  }, [_vm._v("Tất cả")])])], 2) : _vm._e(), _vm._v(" "), (_vm.compareFeeHelpers.errors && _vm.getCrossCheckKind(_vm.CROSS_CHECK_TYPE.FEE)) ? _c('el-radio-group', {
    staticClass: "status-listting",
    attrs: {
      "fill": _vm.listtingComparesErrorBg[_vm.filters.error_id]
    },
    on: {
      "change": _vm.filter
    },
    model: {
      value: (_vm.filters.error_id),
      callback: function($$v) {
        _vm.$set(_vm.filters, "error_id", $$v)
      },
      expression: "filters.error_id"
    }
  }, [_vm._l((_vm.compareFeeHelpers.errors), function(error, index) {
    var _obj;

    return _c('el-radio-button', {
      key: index,
      attrs: {
        "label": index
      }
    }, [_vm._v("\n                • " + _vm._s(error) + " "), _c('span', {
      class: ( _obj = {}, _obj[_vm.listtingComparesError[index]] = _vm.filters.error_id !== index, _obj )
    }, [_vm._v("(" + _vm._s(_vm.countErrorCompare(index)) + ")")])])
  }), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": -1
    }
  }, [_vm._v("\n                • "), _c('span', {
    class: ( _obj$1 = {}, _obj$1[_vm.listtingComparesError[-1]] = _vm.filters.error_id !== -1, _obj$1 )
  }, [_vm._v("Tất cả")])])], 2) : _vm._e(), _vm._v(" "), (_vm.compareHelpers.errors_fee_1 && _vm.getCrossCheckKind(_vm.CROSS_CHECK_TYPE.FEE1)) ? _c('el-radio-group', {
    staticClass: "status-listting",
    attrs: {
      "fill": _vm.listtingComparesErrorBg[_vm.filters.error_id]
    },
    on: {
      "change": _vm.filter
    },
    model: {
      value: (_vm.filters.error_id),
      callback: function($$v) {
        _vm.$set(_vm.filters, "error_id", $$v)
      },
      expression: "filters.error_id"
    }
  }, [_vm._l((_vm.compareHelpers.errors_fee_1), function(error, index) {
    var _obj;

    return _c('el-radio-button', {
      key: index,
      attrs: {
        "label": index
      }
    }, [_vm._v("\n                • " + _vm._s(error) + " "), _c('span', {
      class: ( _obj = {}, _obj[_vm.listtingComparesError[index]] = _vm.filters.error_id !== index, _obj )
    }, [_vm._v("(" + _vm._s(_vm.countErrorCompare(index)) + ")")])])
  }), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": -1
    }
  }, [_vm._v("\n                • "), _c('span', {
    class: ( _obj$2 = {}, _obj$2[_vm.listtingComparesError[-1]] = _vm.filters.error_id !== -1, _obj$2 )
  }, [_vm._v("Tất cả")])])], 2) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('section', {
    staticStyle: {
      "display": "flex",
      "flex-wrap": "wrap"
    },
    attrs: {
      "slot": "inline-filters"
    },
    slot: "inline-filters"
  }, [_c('el-popover', {
    ref: "removeErrorShipmentPopup",
    attrs: {
      "placement": "top",
      "width": "200"
    },
    model: {
      value: (_vm.removeErrorShipmentPopup),
      callback: function($$v) {
        _vm.removeErrorShipmentPopup = $$v
      },
      expression: "removeErrorShipmentPopup"
    }
  }, [(_vm.filters.error_id) ? _c('p', [_vm._v("Xoá tất cả vận đơn: "), _c('code', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm.getErrorText()))]), _vm._v(" ?\n          ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "right",
      "margin": "0"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.removeErrorShipmentPopup = false
      }
    }
  }, [_vm._v("Không")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "disabled": _vm.removeErrorShipmentSubmitting
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.removeAllErrorShipment.apply(null, arguments)
      }
    }
  }, [_vm._v("Xác\n              nhận")])], 1)]), _vm._v(" "), (_vm.filters.error_id != -1) ? _c('el-button', {
    directives: [{
      name: "popover",
      rawName: "v-popover:removeErrorShipmentPopup",
      arg: "removeErrorShipmentPopup"
    }],
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.removeErrorShipmentPopup = !_vm.removeErrorShipmentPopup
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _vm._v(" Xoá tất cả")]) : _vm._e(), _vm._v(" "), (_vm.filters.error_id == 1) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "disabled": _vm.countErrorCompare(1) === 0
    },
    on: {
      "click": _vm.resyncCode
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Đồng bộ\n          code")]) : _vm._e(), _vm._v(" "), (_vm.filters.error_id != -1) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.exportExcelCompare
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" Xuất excel\n        ")]) : _vm._e(), _vm._v(" "), (_vm.filters.error_id == 3) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "disabled": _vm.countErrorCompare(3) === 0
    },
    on: {
      "click": _vm.resyncCode
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Đồng bộ đối soát\n        ")]) : _vm._e(), _vm._v(" "), (_vm.filters.error_id == 6) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "disabled": _vm.countErrorCompare(6) === 0
    },
    on: {
      "click": _vm.updateWeight
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Đồng bộ\n          cân")]) : _vm._e(), _vm._v(" "), (_vm.filters.error_id == 5 || _vm.filters.error_id == 7) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "disabled": _vm.filters.error_id == 5 ? _vm.countErrorCompare(5) === 0 : _vm.countErrorCompare(7) === 0
    },
    on: {
      "click": _vm.updateFeeCarrier
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Cập nhật theo phí hãng\n        ")]) : _vm._e()], 1)])] : _vm._e(), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": 'Sửa đối soát:: ' + _vm.currentListtingCompare.code,
      "visible": _vm.editModal
    },
    on: {
      "update:visible": function($event) {
        _vm.editModal = $event
      }
    }
  }, [_c('el-form', {
    ref: "editListtingCompare",
    attrs: {
      "model": _vm.currentListtingCompare,
      "label-width": "200px",
      "label-position": "top"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateBeforeSubmitEditCompare('editListtingCompare')
      }
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [(_vm.getCrossCheckKind(_vm.CROSS_CHECK_TYPE.COD)) ? _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Tiền thu hộ (COD)"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.currentListtingCompare.cod_amount),
      callback: function($$v) {
        _vm.$set(_vm.currentListtingCompare, "cod_amount", $$v)
      },
      expression: "currentListtingCompare.cod_amount"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Tổng phí"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Tổng phí"
    },
    model: {
      value: (_vm.currentListtingCompare.total_fee),
      callback: function($$v) {
        _vm.$set(_vm.currentListtingCompare, "total_fee", $$v)
      },
      expression: "currentListtingCompare.total_fee"
    }
  })], 1)], 1), _vm._v(" "), (_vm.getCrossCheckKind(_vm.CROSS_CHECK_TYPE.COD)) ? _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Cân nặng"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Cân nặng"
    },
    model: {
      value: (_vm.currentListtingCompare.weight),
      callback: function($$v) {
        _vm.$set(_vm.currentListtingCompare, "weight", $$v)
      },
      expression: "currentListtingCompare.weight"
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', [_c('button', {
    staticClass: "ui blue basic small button",
    attrs: {
      "disable": _vm.submitting,
      "native-type": "submit"
    }
  }, [_vm._v("Lưu lại")])])], 1)], 1)], 2), _vm._v(" "), _c('dialog-add-shipment-to-compare', {
    attrs: {
      "type": _vm.crossChecks.kind
    },
    on: {
      "success": _vm.reloadDataListCompare
    },
    model: {
      value: (_vm.addShipmentModal),
      callback: function($$v) {
        _vm.addShipmentModal = $$v
      },
      expression: "addShipmentModal"
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": ("Cập nhật thông tin vận đơn: " + (_vm.localShipment.code)),
      "visible": _vm.editShipmentModal,
      "width": "100%"
    },
    on: {
      "close": _vm.closeModalShipment,
      "update:visible": function($event) {
        _vm.editShipmentModal = $event
      }
    }
  }, [(_vm.localShipment.id) ? _c('upgrade-shipment', {
    attrs: {
      "shipment-id": _vm.localShipment.id
    },
    on: {
      "edit-shipment-success": _vm.editShipmentSuccess
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8f325c86"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/compare/ListtingCompare.vue
// module id = 654
// module chunks = 1